import { cn } from "@/lib/utils";
import { Loader } from "lucide-react";
import { forwardRef } from "react";

const FilledButton = forwardRef(
  (
    {
      icon,
      text,
      disabled,
      className,
      isLoading = false,
      styles,
      ...props
    }: {
      icon?: React.ReactNode;
      text: string;
      disabled?: boolean;
      className?: string;
      isLoading?: boolean;
      styles?: {
        icon?: string;
      };
    } & React.ComponentProps<"button">,
    ref,
  ) => {
    return (
      <button
        ref={ref as React.RefObject<HTMLButtonElement>}
        type="button"
        disabled={disabled}
        className={cn(
          "w-fit appearance-none border-0 outline-none shadow-none m-0 p-0 bg-neutral-100 flex items-center justify-center gap-1 py-1 px-[6px] rounded-[4px] text-primary caption-2-medium group",
          {
            "!bg-neutral-100 !opacity-50 !text-primary": disabled && !isLoading,
            "hover:bg-neutral-100 hover:bg-[linear-gradient(0deg,rgba(0,0,0,0.03)_0%,rgba(0,0,0,0.03)_100%)] active:bg-neutral-100 active:bg-[linear-gradient(0deg,rgba(0,0,0,0.06)_0%,rgba(0,0,0,0.06)_100%)] active:shadow-none focus:bg-neutral-900 focus:shadow-button-focus focus:text-white":
              !disabled && !isLoading,
            "bg-neutral-100 bg-[linear-gradient(0deg,rgba(0,0,0,0.06)_0%,rgba(0,0,0,0.06)_100%)] cursor-default":
              isLoading,
          },
          className,
        )}
        {...props}
      >
        {isLoading ? (
          <Loader
            className={cn(
              "w-3 h-3 text-[#171717] animate-spin  group-focus:text-white",
              styles?.icon,
            )}
          />
        ) : (
          icon
        )}
        {!isLoading && text}
      </button>
    );
  },
);

FilledButton.displayName = "FilledButton";

export { FilledButton };
export default FilledButton;
